import { useEffect } from "react";
import { useModelPropertiesStore } from "../../store/modelPropertiesStore/modelPropertiesStore"
import { useServicesState } from "../../store/servicesStateStore";

export const AnnotationDirectionUpdaterComponent = () => {

    const rotationOffset = useModelPropertiesStore(state => state.rotationOffset);

    useEffect(() => {
        const docManager = useServicesState.getState().sceneDocumentManager;
        docManager.annotationDirectionChanged(rotationOffset);
    }, [rotationOffset]);

    return <></>
}